import axios from "../helpers/axioxInstance";
import URLS from "../constData/urls";

const tableURlMapping = {
  zipFile: URLS.DRM_CEA_PROFILE_ZIP_DOWNLOAD,
};

export const fetchDrmCEAReportZipData = async () => {
  const url = tableURlMapping["zipFile"];

  if (!url) {
    throw new Error("Invalid table mapping: zipFile");
  }

 
    const response = await axios.get(url);

    if (response.status >= 400) {
    throw new Error(response.message);
    }
    return response.data;
  
};
